import { Loader } from '../Loader'

import {
  ColorType,
  VariantType,
  SizeObject,
  SizeString,
  SizeType,
  ChildrenContainer,
  HTMLButton,
  LoaderContainer,
} from './Button.styled'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean
  variant?: VariantType
  color?: ColorType
  size?: SizeType
}

export const Button = (props: Props): JSX.Element => {
  const defaultSize: SizeString = 'small'

  const { children, isLoading, variant = 'outline', color = 'neutral', size = defaultSize, ...buttonProps } = props

  const isStringSize = typeof size == 'string'

  const formattedSize: SizeObject = {
    default: (isStringSize ? size : size.default) || defaultSize,
    mobile: isStringSize ? size : size.mobile,
    tablet: isStringSize ? size : size.tablet,
    desktop: isStringSize ? size : size.desktop,
  }

  return (
    <HTMLButton variant={variant} color={color} size={formattedSize} {...buttonProps}>
      {isLoading && (
        <LoaderContainer>
          <Loader size={14} />
        </LoaderContainer>
      )}
      <ChildrenContainer isLoading={isLoading}>{children}</ChildrenContainer>
    </HTMLButton>
  )
}
